/**
 * Source / IP-partner catalog.
 *
 * The Kai App displays content authority (e.g. on Why This Matters sections,
 * tooltip body content, indicator rationale) so users know where the clinical
 * guidance came from. PLA-252 establishes the registry; future tickets add
 * the consumer surfaces and additional source entries (Mariana Health for
 * system leakage, medical-group internal content, Open Evidence, etc.).
 *
 * Anywhere we render content sourced from one of these partners, build a
 * `Source[]` from this catalog and hand it to `<SourceAttribution sources={…} />`.
 * Never reference `TSG_SOURCE` inside the component — the component must stay
 * source-agnostic so multi-source / tabbed rendering works without rewrites.
 */

export type SourceId = 'tsg' | 'mariana' | 'open-evidence' | 'medical-group';

export interface Source {
  id: SourceId;
  /** Display name shown next to the logo. */
  name: string;
  /** Optional short caption ("Content Authority", "System Leakage", etc.). */
  caption?: string;
  /** Path to the logo asset relative to public/. */
  logoSrc: string;
  /** Alt text used for the <img>. */
  logoAlt: string;
  /** Optional outbound link, e.g. partner site. */
  href?: string;
}

export const TSG_SOURCE: Source = {
  id: 'tsg',
  name: 'The Sullivan Group',
  caption: 'Content Authority',
  logoSrc: '/icons/tsg-logo.png',
  logoAlt: 'The Sullivan Group',
};
